import { render, staticRenderFns } from "./PowerMode.vue?vue&type=template&id=473d025c&scoped=true"
import script from "./PowerMode.vue?vue&type=script&lang=js"
export * from "./PowerMode.vue?vue&type=script&lang=js"
import style0 from "./PowerMode.vue?vue&type=style&index=0&id=473d025c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d025c",
  null
  
)

export default component.exports